import React from 'react'
import Text from '../../atoms/text/Text'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import InlineGroup from '../../atoms/inlinegroup/InlineGroup'
import Icon from '../../atoms/icon/Icon'
import { startCase } from '../../../services/utils'
import { percentage } from '../model/utils/formatters'

interface Props {
  data: ModelAPI.Reporting.MarketDebrief[]
}

const getIconName = (type: API.Products) => {
  switch (type) {
    case 'HOME_LOANS': return 'homeLoans'
    case 'BUSINESS_LOANS': return 'businessLoans'
    case 'DEPOSITS': return 'deposits'
    case 'CREDIT_CARDS': return 'creditCards'
    case 'WEALTH_MANAGEMENT': return 'wealthManagement'
    case 'INSTITUTIONAL_BANKING': return 'institutionalBanking'
    case 'OFFSHORE_BANK': return 'offshoreBank'
    default: return 'homeLoans'
  }
}

const getIconColour = (type: API.Products) => {
  switch (type) {
    case 'HOME_LOANS': return 'orange'
    case 'BUSINESS_LOANS': return 'blue'
    case 'DEPOSITS': return 'purple'
    default: return 'green'
  }
}

const RoundResultsMarketDebrief: React.FC<Props> = ({ data }) => {
  return (
    <VerticalGroup full center wide>
      <Text size='6xl' bold colour='primaryDark' className='mb-20'>Market Debrief</Text>
      <VerticalGroup full wide center style={{maxWidth: '900px'}}>
        <InlineGroup spread block>
          <InlineGroup style={{width: '40%'}} className='pt-2 pb-2'>
            <Text></Text>
          </InlineGroup>
          <InlineGroup style={{width: '30%'}} center>
            <Text size='4xl' bold center>Growth</Text>
          </InlineGroup>
          <InlineGroup style={{width: '30%'}} center>
            <Text size='4xl' bold center>Losses</Text>
          </InlineGroup>
        </InlineGroup>
        {data.map((d, i) => (
          <InlineGroup key={i} spread block verticalCenter>
            <InlineGroup style={{width: '40%'}} verticalCenter className='pt-2 pb-2'>
              <Icon size={12} type={getIconName(d.type)} colour={getIconColour(d.type)}></Icon>
              <Text size='3xl' className='ml-2'>{startCase(d.name)}</Text>
            </InlineGroup>
            <InlineGroup style={{width: '30%'}} center>
              <Text size='3xl'>{percentage(d.growth, 1, false, true)}</Text>
            </InlineGroup>
            <InlineGroup style={{width: '30%'}} center>
              <Text size='3xl'>{d.losses == null ? 'N/A' : d.losses.map(l => percentage(l, 2, false, true)).join(' - ')}</Text>
            </InlineGroup>
          </InlineGroup>
        ))}
      </VerticalGroup>
    </VerticalGroup>
  )
}

export default RoundResultsMarketDebrief